import { User } from "model/user";

/**
 * Whether the user reviews the Search Agent's suggested Lead Readiness updates: the Search Agent
 * entitlement, the extended lead fields the suggestions change, and the Search Agent turned on
 * (without it there is no Search Agent tab to hold the card or the badge).
 */
export const canReviewLeadProfileSuggestions = (user: User | undefined) => {
	return !!user
		&& user.permissions.aiSearchAgent === true
		&& user.permissions.extendedLeadFields === true
		&& user.searchAgentEnabled === true;
};
